import { action } from 'typesafe-actions';

import { SignUpTypes } from './types';

export const startLoadingAction = () => action(SignUpTypes.START_LOADING);
export const stopLoadingAction = () => action(SignUpTypes.STOP_LOADING);
